import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, Text, Dimensions, StyleSheet, TouchableOpacity } from 'react-native';
import Modal from 'react-native-modal';

import Colors from '../../constants/Colors';
import timeUtils from '../../utils/timeUtils';

class ConfirmCancel extends PureComponent {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    translation: PropTypes.objectOf(PropTypes.any).isRequired,
    visit: PropTypes.objectOf(PropTypes.any).isRequired,
    pantry: PropTypes.objectOf(PropTypes.any).isRequired,
    organizationId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super();
  }

  cancelCancel = () => {
    const { actions } = this.props;
    actions.closeCancelAppointment();
  };

  confirmCancel = () => {
    const { actions, visit, organizationId } = this.props;
    actions.confirmCancelAppointment(visit.id, organizationId);
  };

  render() {
    const { translation, visit } = this.props;
    const labels = {
      question: translation.confirm_cancel_visit,
      cancel: translation.cancel_visit,
      back: translation.fragment_registration_personal_button_back,
      yes: translation.yes_cancel,
    };
    const confirmTitle = `${labels.cancel} ${timeUtils.friendlyDateTime(visit.dateTime)}`;
    const confirmQuestion = labels.question;

    const deviceWidth = Dimensions.get('screen').width;
    const deviceHeight = Dimensions.get('screen').height;

    return (
      <View style={styles.container}>
        <Modal isVisible deviceWidth={deviceWidth} deviceHeight={deviceHeight} style={styles.modal}>
          <View style={styles.modalForm}>
            <View style={styles.contentContaier}>
              <Text style={styles.text}>{confirmTitle}</Text>
              <Text style={styles.text}>{confirmQuestion}</Text>
            </View>
            <View style={styles.buttonContainer}>
              <TouchableOpacity style={styles.backButton} onPress={this.cancelCancel}>
                <Text style={styles.changeTime}>{labels.back}</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.cancelButton} onPress={this.confirmCancel}>
                <Text style={styles.cancelVisit}>{labels.yes}</Text>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  modal: {
    alignItems: 'center',
  },
  modalForm: {
    width: 280,
    height: 230,
    backgroundColor: Colors.white,
    borderRadius: 2,
    justifyContent: 'space-between',
  },
  contentContaier: {
    paddingTop: 30,
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 24,
  },
  buttonContainer: {
    backgroundColor: Colors.lightGrayBackground,
    borderTopWidth: 1,
    borderTopColor: Colors.grayBorder,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  text: {
    fontSize: 20,
    lineHeight: 28,
  },
  backButton: {
    height: 56,
    paddingLeft: 8,
    paddingRight: 8,
  },
  cancelButton: {
    height: 36,
    margin: 8,
    paddingLeft: 16,
    paddingRight: 16,
    borderRadius: 2,
    backgroundColor: Colors.brightRed,
  },
  changeTime: {
    textTransform: 'uppercase',
    fontWeight: '600',
    lineHeight: 56,
  },
  cancelVisit: {
    textTransform: 'uppercase',
    fontWeight: '600',
    color: Colors.white,
    lineHeight: 36,
  },
});

export default ConfirmCancel;
